"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const prop_types_1 = require("prop-types");
const DirectBook_1 = __importDefault(require("./components/DirectBook"));
const getInitialContext_1 = __importDefault(require("./stateMachine/getInitialContext"));
const main_1 = require("./stateMachine/machines/main");
const epicOSWUtils_1 = require("./lib/epicOSWUtils");
const covidVaccineUtils_1 = require("./lib/covidVaccineUtils");
const config_1 = require("./lib/constants/config");
const configUtils_1 = require("./lib/configUtils");
const thirdPartyLogin_1 = require("./lib/constants/thirdPartyLogin");
const Visibility_1 = require("./lib/constants/Visibility");
const utils_1 = require("./lib/utils");
const getDevLogger = () => {
    if (process.env.NODE_ENV !== 'development') {
        return () => { };
    }
    return (state) => {
        /*eslint-disable no-console */
        if (console && console.groupCollapsed && console.log && console.groupEnd) {
            console.group(`[MachineTransition]: `);
            console.log(state.value, Object.assign({}, state));
            console.groupEnd();
        }
        /*eslint-enable no-console */
    };
};
const propTypes = {
    /**
     * direct booking config
     * This will contain things like messages for `react-intl`, button placement
     * form layout etc..
     */
    /* eslint-disable react/forbid-prop-types */
    config: prop_types_1.object.isRequired,
    /**
     * Feature flags that enable parallel development of new features/experiences
     * without impacting the existing production experience. This allows:
     * 1. Development and testing of new features
     * 2. Selective enablement for specific customers or environments before general availability
     * 3. Safe development and validation of major changes without affecting production users
     */
    darkshipFeatureFlags: prop_types_1.object,
    // Tell the widget if the search match is enabled
    searchMatchEnabled: prop_types_1.bool.isRequired,
    /**
     * Suggest that direct book should render alternate providers at various steps
     */
    featureFlags: (0, prop_types_1.shape)({
        // Suggest alternate providers for step 1
        dbw_suggest_alt_providers_for_step_1: prop_types_1.bool,
        // Suggest alternate providers for step 2
        dbw_suggest_alt_providers_for_step_2: prop_types_1.bool,
        // Render the direct book widget in a drawer
        dbw_render_in_drawer: prop_types_1.bool
    }),
    /**
     * Which provider are we booking
     */
    providerId: (0, prop_types_1.oneOfType)([prop_types_1.number, prop_types_1.string]).isRequired,
    /**
     * csrftoken used in POST requests
     */
    csrfToken: prop_types_1.string.isRequired,
    /**
     * An object containing various callbacks representing API requests, URL creation,
     * and other domain specific knowledge that should be specified by the consuming application.
     *
     * Please check the readme for information on how to construct the callbacks.
     */
    services: (0, prop_types_1.shape)({
        createAvailabilityUrl: prop_types_1.func,
        createProviderUrl: prop_types_1.func,
        getAltProviders: prop_types_1.func,
        getEhrPatientDemographics: prop_types_1.func,
        getEhrPatientProxyDemographics: prop_types_1.func,
        getProviderById: prop_types_1.func.isRequired,
        getCareTeamsProviders: prop_types_1.func.isRequired
    }),
    /**
     * Callback triggered for tracking
     * @callback onDidBook
     * @param {string} eventName
     * @param {object} eventData
     */
    track: prop_types_1.func.isRequired,
    /**
     * Google maps api key.
     * If this isn't provided, it's assummed that window.google.maps
     * has already beeen loaded on the page
     */
    mapApiKey: prop_types_1.string,
    /**
     * AWS map API key, map name, and region name
     * {
     *  apiKey: string,
     *  mapName: string,
     *  regionName: string,
     * }
     */
    awsMapConfig: prop_types_1.object,
    /**
     * Callback triggered after a successful booking
     * @callback onDidBook
     * @param {object} appointment
     * @param {object} provider
     * @param {object} location
     */
    onDidBook: prop_types_1.func,
    /**
     * Determines if an appointment summary screen be displayed after a
     * sucessful booking. e.g:
     * If the consumer of this widget will be routing to a different
     * page after receiving the `onDidBook` callback, they may not
     * want to display an appt summary to avoid flashing a view before re-routing
     */
    showApptSummary: prop_types_1.bool,
    /**
     * params used to pre-populate data and deep link into certain steps. e.g:
     * if we have a valid `patientRel` and `purpose` skip the `apptInfo` step
     */
    deepLinkingParams: (0, prop_types_1.shape)({
        patientRel: prop_types_1.string,
        purpose: prop_types_1.string,
        locationId: prop_types_1.string,
        periodStart: prop_types_1.string
    }),
    /**
     * params necessary to get patient demographics in the case of an EHR integration
     * pid + pid_type + source_system form the body of the /api/patient/demographics call
     */
    ehr: (0, prop_types_1.shape)({
        pid: prop_types_1.string,
        pid_type: prop_types_1.string,
        source_system: prop_types_1.string,
        show_dropdown: prop_types_1.bool,
        show_related: prop_types_1.bool
    }),
    /**
     * Optional react-router history object. If provided, direct book will use it
     * to control the url between steps of the booking flow
     */
    history: prop_types_1.object,
    customerCode: prop_types_1.string.isRequired,
    /**
     * An object containing properties needed for third-party login/logout.
     * Includes:
     * * prop indicating current login status
     * * objects containing URLs/callbacks for login and logout
     */
    thirdPartyLoginProps: (0, prop_types_1.shape)({
        /**
         * Indicates which third-party config is active.
         */
        type: (0, prop_types_1.oneOf)(['mychart']).isRequired,
        /**
         * Indicates whether the user is currently logged in to the given
         * third-party.
         */
        isLoggedIn: prop_types_1.bool.isRequired,
        /**
         * Properties related to third-party login.
         */
        login: (0, prop_types_1.shape)({
            /**
             * The URL for the third-party login page.
             * The login.callback will handle redirecting the user, this is just
             * included to show the user an href when hovering the button.
             */
            url: prop_types_1.string,
            /**
             * A callback to use for the third-party login button.
             * The function should handle:
             * - Creating a deeplink URL to return user to where they were in the DBW flow
             * - Appending this URL to the router history to enable users to hit 'back' from third-party login
             * - Saving off deeplink data to be used on third-party login authenticated redirect
             * - Redirecting the user to the third-party login page
             * @callback callback
             * @param {object} deepLinkingParams an Object in the shape of
             * {
             *    patientRel: string,
             *    purpose: string,
             *    locationId: string,
             * }
             */
            callback: prop_types_1.func.isRequired
        }).isRequired,
        /**
         * Properties related to third-party logout.
         */
        logout: (0, prop_types_1.shape)({
            /**
             * The URL for the third-party logout page.
             * The logout.callback will handle redirecting the user, this is just
             * included to show the user an href when hovering the button.
             */
            url: prop_types_1.string,
            /**
             * A callback to use for the third-party logout button.
             * The function should handle:
             * - Cleaning up/removing any state related to the third-party login
             * - Trigger an invalidation of the login session with the third-party (if needed)
             * - Handling any redirects
             * @callback callback
             * @param {object} deepLinkingParams an Object in the shape of
             * {
             *    patientRel: string,
             *    purpose: string,
             *    locationId: string,
             * }
             */
            callback: prop_types_1.func.isRequired
        }).isRequired,
        errors: (0, prop_types_1.arrayOf)((0, prop_types_1.oneOf)(Object.values(thirdPartyLogin_1.ERROR)))
    }),
    /**
     * values used to filter appointments by user type - agent vs. consumer
     * passed as a filter params to scheduling and availability services
     */
    visibility: (0, prop_types_1.shape)({
        role: prop_types_1.string.isRequired,
        schedulingVisibility: prop_types_1.string.isRequired,
        isVisibilityAgent: prop_types_1.bool
    }),
    /**
     * Contextual information is sent to the GX backend API.
     * Use cases:
     * - If certain conditional questions that a provider may have configured should be asked or skipped.
     * - If a provider has a Clinical Validation (CV) question configured to be asked conditionally, then any searched clinical_keyword will be passed along so that the CV question will be skipped since the customer has already answered the clinical search question in their initial search.
     */
    gxContextualInfo: (0, prop_types_1.shape)({
        context: {
            clinical_keyword: prop_types_1.string
        }
    }),
    /**
     * Determines whether appointment times will be rendered in the `default` vertical list or a `dense` multi-column list
     */
    apptDensity: (0, prop_types_1.oneOf)(['default', 'dense']),
    /* Properties for the appointment purpose filter controls */
    apptPurposeFilterProps: (0, prop_types_1.shape)({
        /* Specifies the minimum number of appointment purposes before the filter controls are displayed */
        minPurposesForFilter: prop_types_1.number,
        /* Labels for rendering the filter controls */
        labels: (0, prop_types_1.shape)({
            noResultsLabel: prop_types_1.string,
            purposeSearchLabel: prop_types_1.string,
            purposeSearchPlaceholderLabel: prop_types_1.string,
            visitTypeAllLabel: prop_types_1.string,
            visitTypeInPersonLabel: prop_types_1.string,
            visitTypeVirtualLabel: prop_types_1.string
        }),
        /* Function executed when the name filter changes */
        onNameFilterChange: prop_types_1.func,
        /* Function executed when the visit type filter changes */
        onVisitTypeFilterChange: prop_types_1.func,
        /* Function executed when the filters are cleared */
        onClearFilters: prop_types_1.func
    }),
    /**
     * The property to check on a provider to see if direct book is enabled for them.
     * If undefined, will skip the check.
     */
    dbEnabledProperty: prop_types_1.string,
    /**
     * Function executed when scrolling is triggered within the direct book flow, typically on step change.
     * Defaults to `() => window.scrollTo(0, 0)`
     */
    onScroll: prop_types_1.func,
    /**
     * Will be passed as 'X-Consumer-Username' for `getAvailableLocsForProvider` & `getAvailableApptPurposesForProvider`.
     * These api methods still use an internal instance of `@kyruus/search-sdk`.
     * Will be passed as 'channel' for `bookAppointment`.
     * Analytics uses theses values to differentiate search and scheduling traffic for
     * different Kyruus products and different personas within the PMC product.
     */
    productName: prop_types_1.oneOf[('pmc', 'agent', 'employed_user', 'UNKNOWN')],
    appointmentEhrId: prop_types_1.string,
    /**
     * Optional string that will be prepended to the base URL for API calls
     * initiated from code within this widget. Defaults to making relative
     * calls on the local domain if not supplied.
     */
    apiBaseURL: prop_types_1.string
};
const defaultProps = {
    mapApiKey: null,
    onDidBook: () => { },
    showApptSummary: true,
    deepLinkingParams: {},
    ehr: null,
    history: null,
    services: {
        createAvailabilityUrl: () => {
            throw new Error('createAvailabilityUrl callback not defined');
        },
        createProviderUrl: () => {
            throw new Error('createProviderUrl callback not defined');
        },
        getAltProviders: () => {
            throw new Error('getAltProviders callback not defined');
        },
        getEhrPatientDemographics: () => {
            throw new Error('getEhrPatientDemographics callback not defined');
        },
        getEhrPatientProxyDemographics: () => {
            throw new Error('getEhrPatientProxyDemographics callback not defined');
        },
        getProviderById: () => {
            throw new Error('getProviderById callback not defined');
        },
        getCareTeamsProviders: () => {
            throw new Error('getCareTeamsProviders callback not defined');
        },
        getPatientRegForm: () => {
            throw new Error('getPatientRegForm callback not defined');
        },
        createAppointmentWaitList: () => {
            throw new Error('createAppointmentWaitList callback not defined');
        }
    },
    gxContextualInfo: {},
    visibility: {
        role: Visibility_1.CONSUMER_ROLE,
        schedulingVisibility: Visibility_1.SCHEDULING_VISIBILITY_CONSUMER,
        isVisibilityAgent: false
    },
    apptDensity: 'default',
    apptPurposeFilterProps: {
        minPurposesForFilter: Number.POSITIVE_INFINITY
    },
    onScroll: () => window.scrollTo(0, 0),
    productName: 'pmc',
    featureFlags: {
        dbw_suggest_alt_providers_for_step_1: false,
        dbw_suggest_alt_providers_for_step_2: false,
        dbw_render_in_drawer: false
    },
    darkshipFeatureFlags: {},
    appointmentEhrId: null,
    apiBaseURL: ''
};
function DirectBookWidget({ config, providerId, csrfToken, services, track, customerCode, searchMatchEnabled, featureFlags, darkshipFeatureFlags = defaultProps.darkshipFeatureFlags, productName = defaultProps.productName, dbEnabledProperty, mapApiKey = defaultProps.mapApiKey, awsMapConfig, onDidBook = defaultProps.onDidBook, thirdPartyLoginProps, showApptSummary = defaultProps.showApptSummary, deepLinkingParams = defaultProps.deepLinkingParams, ehr = defaultProps.ehr, history = defaultProps.history, gxContextualInfo = defaultProps.gxContextualInfo, visibility = defaultProps.visibility, apptDensity = defaultProps.apptDensity, apptPurposeFilterProps = defaultProps.apptPurposeFilterProps, onScroll = defaultProps.onScroll, appointmentEhrId = defaultProps.appointmentEhrId, apiBaseURL = defaultProps.apiBaseURL }) {
    const isOrderBasedSchedulingFlow = (0, utils_1.isOrderBasedScheduling)() && !!appointmentEhrId;
    const trackProvider = (0, react_1.useCallback)((message, event_data = {}) => {
        const modifiedEventData = Object.assign(Object.assign({}, event_data), { provider_id: providerId });
        if (isOrderBasedSchedulingFlow) {
            modifiedEventData.appointmentEhrId = appointmentEhrId;
            modifiedEventData.source = config_1.CERNER_EMBEDDED_ORDER_BASED_APPOINTMENT;
        }
        return track(message, Object.assign({}, modifiedEventData));
    }, [track, providerId, isOrderBasedSchedulingFlow]);
    const initialContext = (0, getInitialContext_1.default)();
    const machine = (0, react_1.useRef)((0, main_1.createMainMachine)({
        context: Object.assign(Object.assign({}, initialContext), { csrfToken,
            onDidBook,
            showApptSummary,
            providerId,
            deepLinkingParams,
            ehr, services: Object.assign(Object.assign({}, defaultProps.services), services), epicOSWConfig: (0, epicOSWUtils_1.getEpicOSWConfig)(config), covidVaccinePatientRegFormConfig: (0, covidVaccineUtils_1.getCovidPatientRegFormConfig)(config), patientRegFormConfig: config.patient_reg_form, covidUseDefaultStepOrder: (0, covidVaccineUtils_1.getCovidShouldUseDefaultStepOrder)(config), useProviderInsuranceOnRegForm: (0, configUtils_1.getUseProviderInsuranceOnRegForm)(config), hideHeader: config.hide_header, hidePatientRelConfig: config[config_1.HIDE_PATIENT_REL_FOR_LOCATIONS], customerCode,
            productName, gx: Object.assign(Object.assign({}, initialContext.gx), { contextualInfo: gxContextualInfo }), visibility,
            dbEnabledProperty,
            featureFlags,
            searchMatchEnabled,
            darkshipFeatureFlags,
            isOrderBasedSchedulingFlow,
            appointmentEhrId,
            apiBaseURL })
    }));
    return (react_1.default.createElement(DirectBook_1.default, { config: config, searchMatchEnabled: searchMatchEnabled, featureFlags: featureFlags, darkshipFeatureFlags: darkshipFeatureFlags, mapApiKey: mapApiKey, awsMapConfig: awsMapConfig, machine: machine.current, thirdPartyLoginProps: thirdPartyLoginProps, logState: getDevLogger(), track: trackProvider, history: history, apptDensity: apptDensity, apptPurposeFilterProps: apptPurposeFilterProps, onScroll: onScroll }));
}
exports.default = DirectBookWidget;
DirectBookWidget.propTypes = propTypes;
DirectBookWidget.defaultProps = defaultProps;
//# sourceMappingURL=DirectBookWidget.js.map